import React from 'react';
import { LinkItem } from '@atlaskit/menu';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { useRouter } from '@atlassian/react-resource-router';
import { useBoardSettingsUrl } from '@atlassian/jira-software-board-settings-rapidboard-config-common/src/controllers/use-board-settings-url/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { getWillShowNav4 } from '@atlassian/jira-navigation-apps-sidebar-nav4-rollout-core/src/common/utils/get-will-show-nav4/index.tsx';
import { functionWithCondition } from '@atlassian/jira-feature-flagging-utils';
import messages from './messages.tsx';

export const readSelectedConfigTab = (): string => {
	const defaultValue = 'filter';
	try {
		const value = localStorage.getItem('selectedConfigTab');
		return value ? JSON.parse(value) : defaultValue;
	} catch (err) {
		log.safeErrorWithoutCustomerData(
			'software-backlog.header.menu.configure-board-item.dropdown-item',
			`Error reading "selectedConfigTab" value: ${err}`,
		);
		return defaultValue;
	}
};

export const ConfigureBoardItem = () => {
	const { formatMessage } = useIntl();
	const selectedConfigTab = readSelectedConfigTab();
	const url = useBoardSettingsUrlFn(selectedConfigTab);

	return (
		<LinkItem
			data-testid="software-backlog.header.menu.configure-board-item.dropdown-item"
			href={url}
		>
			{formatMessage(messages.displayText)}
		</LinkItem>
	);
};

const useBoardSettingsUrlFn = functionWithCondition(
	() => getWillShowNav4() && fg('blu-5799-jira-software-board-entrypoint-route'),
	useBoardSettingsNew,
	useBoardSettingsOld,
);

function useBoardSettingsNew(selectedConfigTab: string) {
	const settingsUrl = useBoardSettingsUrl();
	return `${settingsUrl}/${selectedConfigTab}?from-backlog=1`;
}

function useBoardSettingsOld(selectedConfigTab: string) {
	const [{ location }] = useRouter();
	return `${location.pathname}?config=${selectedConfigTab}`;
}

export default ConfigureBoardItem;
